import Axios from "axios";
import fetchUPlus from "../httpFetchUPlus.js";
const UPlusmodelName = "/service/so-dubai/";
const serviceOnlinePath = '/uplus/sosvc/v2/'
const serviceOnlinePublic = '/uplus/'
const solutionBaseUrl = '/uplus/umini.Solution2020/solution/v2/'
/**
 * 公共的埋点【可以送U豆】
 **/
export function insertRecord(data) {
  return fetchUPlus.post('/service/so-cape-town/requestVisitLog/insertRecord.json', data);
}
// 根据分享ID获取分享信息--需要会话
export function getparams4app(data) {
  return fetchUPlus.post(serviceOnlinePublic + "/sharing/v2/getParams4App", data);
}
// 获取账户信息
export function selectSysUserDTO(data) {
  return Axios.get(UPlusmodelName + "sysUser/selectSysUserDTO.json", data).then((res) => {
    return res.data
  }).catch(catchError=>{
    console.error('网络异常')
  })
}
// 下载用户个人信息
export function getExportUserInfo(data) {
  return fetchUPlus.post(serviceOnlinePublic + "/usermgr/v2/getExportUserInfo", data)
}
/**
 * 查询首页轮播图
 * @param {*} data
 * @returns
 */
export function getAdList(data) {
  return fetchUPlus.post(serviceOnlinePublic + "/publicsvc/v2/getBannerList4Uplus", { banner_type: "5001" }).then((res) => {
    return res.data
  }).catch(catchError=>{

  })
}
/**
 * 查询首页直播
 * @param {*} data
 * @returns
 */
export function getLiveList4Portal(data) {
  return fetchUPlus.post(serviceOnlinePublic+"publicsvc/v2/getLiveList4Portal", data).then((res) => {
    return res.data
  }).catch(catchError=>{

  })
}
/**
 * 查询首页推荐课程
 * @param {*} data
 * @returns
 */
export function queryCourseList4Portal(data) {
  return fetchUPlus.post(serviceOnlinePublic+"ulsvc/v2/queryCourseList4Portal", data).then((res) => {
    return res.data
  }).catch(catchError=>{

  })
}
/**
 * 获取机构下拉列表
 **/
export const selectOrganization4inner = params => {
  return fetchUPlus.get(UPlusmodelName + "organization/selectOrganization4inner.json", {params: params});
};
/**
 * 添加客户反馈信息
 **/
export function addCustomerFeedback(data) {
  return fetchUPlus.post(serviceOnlinePath + "addCustomerFeedback", data);
}
/**
 * 查询产品信息列表
 **/
export function queryAdvertiseProducts(data) {
  return fetchUPlus.post(serviceOnlinePath + "queryAdvertiseProducts", data);
}
/**
 * 查询产品详情
 **/
export function queryPrdDetail(data) {
  return fetchUPlus.post(serviceOnlinePath + "queryPrdDetail", data);
}
/**
 * 查询增值模块列表
 **/
export function queryModulesOfPrd(data) {
  return fetchUPlus.post(serviceOnlinePath + "queryModulesOfPrd", data);
}
/**
 * 查询增值模块列表【树形】
 **/
export function queryModuleList(data) {
  return fetchUPlus.post(serviceOnlinePath + "queryModuleList", data);
}
/**
 * 查询增值模块详情
 **/
export function queryModuleDetail(data) {
  return fetchUPlus.post(serviceOnlinePath + "queryModuleDetail", data);
}
/**
 * 获取业务领域列表
 **/
export function getBusinessAreaOptions(data) {
  return fetchUPlus.post(serviceOnlinePath + "getBusinessAreaOptions", data);
}
/**
 * 线索登记/我要咨询
 **/
export function saveSaleClue(data) {
  return fetchUPlus.post(UPlusmodelName + "synergy/saveSaleClue.json", data);
}
/**
 * 获取登录用户基本信息
 **/
export function getUserBaseInfo(data) {
  return fetchUPlus.post(serviceOnlinePath + "getUserBaseInfo", data);
}
/**
 * 查询精选推荐列表-front
 **/
export function selectRecommendationList(data) {
  return fetchUPlus.post(serviceOnlinePath + "selectRecommendationList", data);
}
/**
 * 添加/取消收藏
 **/
export function addOrCancelCollect(data) {
  return fetchUPlus.post(serviceOnlinePath + "addOrCancelCollect", data);
}
/**
 * 查询是否收藏
 **/
export function selectCollectRecord(data) {
  return fetchUPlus.post(serviceOnlinePath + "selectCollectRecord", data);
}
/**
 * 添加精选推荐访问记录
 **/
export function addrecommendationrecord(data) {
  return fetchUPlus.post(serviceOnlinePath + "addRecommendationRecord", data);
}
/**
 * 添加产品访问记录
 **/
export function addProductRecord(data) {
  return fetchUPlus.post(serviceOnlinePath + "addProductRecord", data);
}
/**
 * 添加产品模块访问记录
 **/
export function addModuleRecord(data) {
  return fetchUPlus.post(serviceOnlinePath + "addModuleRecord", data);
}
/**
 * 获取产品解决方案详情
 **/
export function getSolutionDetail4pc(data) {
  return fetchUPlus.post(solutionBaseUrl + "getSolutionDetail4pc", data);
}
/**
 * 产品解决方案添加收藏
 **/
export function addCollection(data) {
  return fetchUPlus.post(solutionBaseUrl + "addCollection", data);
}
/**
 * 产品解决方案取消收藏
 **/
export function deleteCollection(data) {
  return fetchUPlus.post(solutionBaseUrl + "deleteCollection", data);
}
/**
 * 获取行业解决方案列表
 **/
export function getSolutionList4pc(data) {
  return fetchUPlus.post(solutionBaseUrl + "getSolutionList4pc", data);
}
/**
 * 获取热门解决方案列表
 **/
export function getHotSolutionList4pc(data) {
  return fetchUPlus.post(solutionBaseUrl + "getHotSolutionList4pc", data);
}
// 最新解决方案
export function getNewestSolutionList4pc(data) {
  return fetchUPlus.post(solutionBaseUrl + "getNewestSolutionList4pc", data);
}
// 待办数量
export function countBacklogRecordByType(data) {
  return fetchUPlus.post(UPlusmodelName+"backlogRecord/countBacklogRecordByType.json",data);
}

/**
 * 获取用户及其客户经理信息
 **/
export function getUserBaseInfoJson(data) {
  return fetchUPlus.get(UPlusmodelName + "sysUser/getUserBaseInfo.json", data);
}

//获取图形验证码
export function getCaptcha(params) {
  return fetchUPlus.post(serviceOnlinePublic+"chkcodemgr/v2/getCaptcha",params);
}
//校验图形验证码
export function checkCaptcha(params) {
  return fetchUPlus.post(serviceOnlinePublic+"chkcodemgr/v2/checkCaptcha",params);
}
//获取验证码
export function getChkCode(params) {
  return fetchUPlus.post(serviceOnlinePublic+"chkcodemgr/v2/getVerificationCode",params);
}
//校验验证码
export function checkChkCode(params) {
  return fetchUPlus.post(serviceOnlinePublic+"chkcodemgr/v2/checkVerificationCode",params);
}


// WEBPACK FOOTER //
// ./src/gtn/api/uPlusApi/index.js